import ServiceBase from '../../services/ServiceBase';
import indicatorsProxy from '../../../core/proxies/technical/IndicatorsProxy';
import lastPriceProxy from '../../../core/proxies/common/LastPriceProxy';

class IndicatorsService extends ServiceBase {
  getIndicators(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('IndicatorsService.GetIndicators', params)(() =>
          indicatorsProxy.getIndicators(params, source),
        ),
    );
  }
  getLastPriceData(params, source) {
    return this.applyMemoryCache('IndicatorsService.GetLatestPrice', params)(
      () => lastPriceProxy.GetLatestPrice(params, source),
    );
  }
}

const indicatorsService = new IndicatorsService();
export default indicatorsService;
